module.exports = __webpack_public_path__ + "img/EN-Wix-integration-vidjet-step1.307242ef.png";